import { Box } from '@material-ui/core';
import { ContactValidationResult } from 'api/file/interfaces/get-file-order-insights';
import OrderInsightRisks from './OrderInsightRisks';
import StatusRow from './StatusRow';

const ContactInfoDisplay: React.FC<ContactValidationResult> = ({
  transactionId,
  isPhoneMatch,
  phoneCarrier,
  phoneType,
  isPrepaidPhone,
  emailRegisteredDate,
  isAddressMatch,
  risks = [],
  isPdf = false,
  phoneMatchesSubmittedData,
  prepaidPhone,
  streetAddressMatch,
}: ContactValidationResult) => {
  const statuses = [
    { label: 'Phone Matches Submitted Data?', value: phoneMatchesSubmittedData },
    { label: 'Phone Carrier:', value: phoneCarrier },
    { label: 'Phone Type:', value: phoneType },
    { label: 'Is Phone Prepaid?:', value: prepaidPhone },
    { label: 'Email Address First Identified in Public Record:', value: emailRegisteredDate },
    { label: 'Street Address Matches Submitted Data?', value: streetAddressMatch },
  ];
  return (
    <Box>
      {statuses.map((item, idx) => (
        <StatusRow
          key={idx}
          index={idx}
          label={item.label}
          value={item.value}
          isPdf={isPdf}
          isPlainText
          interpretBooleanAsText
        />
      ))}

      <OrderInsightRisks stringAlerts={risks} isPdf={isPdf} />
    </Box>
  );
};

export default ContactInfoDisplay;
